import {Component, Input, OnInit} from '@angular/core';
import {Http} from '@angular/http';
import {Utilities} from '@shared/utilities/utilities.model';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'amd-include-template',
    templateUrl: './include-template.component.html',
    styleUrls: ['./include-template.component.scss']
})
export class IncludeTemplateComponent implements OnInit {
    myTemplate: any = '';
    @Input() url: string;
    @Input() height: number;

    constructor(private http: Http,
                private sanitizer: DomSanitizer) {
    }

    ngOnInit() {
        if (!Utilities.isVoid(this.url)) {
            this.http.get(this.url).subscribe(
                (res) => {
                    if (!Utilities.isVoid(res) && res.status === 200) {
                        this.myTemplate = this.sanitizer.bypassSecurityTrustHtml(res.text());
                    }
                });
        }
    }

}
